export const ENDPOINTS = {
  ASSET_MANAGEMENT: {
    ASSETS: '/me/tokens',
    RFID_ASSETS: '/me/tokens?type=CARD&extendIntegrations=true',
    SHELL_TOKEN: '/me/tokens/shell',
  },
  ONBOARDING: {
    PRODUCTS: '/products',
    ACCOUNT: '/signups/me/account',
    NEW_LEAD: '/signups/me/new',
    USER_PRODUCTS: '/signups/me/products',
    USER_QUESTIONS: '/signups/me/questions',
    USER_STATUS: '/signups/me/status',
    CONFIRM_EMPLOYEE: '/signups/employee-confirm',
    INSTALLATIONS: '/signups/me/installation',
    INSTALLATION_EVENTS: '/installations/me/events',
    INSTALLATION_STATUS: '/installations/me/status',
    FILES: '/signups/me/files',
    PAYMENT_AMOUNT: '/signups/me/payment-amount',
    PAYMENT_METHODS: '/payments/payment-methods',
    DO_PAYMENT: '/payments/do-payment',
    PAYMENT_DETAILS: '/payments/payment-details',
    PAYMENT_STATUS: '/signups/me/payment-status',
    CONFIRM_ORDER: '/signups/me/confirm',
    B2B_EMPLOYEE_SETUP: '/payments/b2b-employee-setup/',
    HAS_RECURRING_PAYMENT_DETAILS:
      '/userpayments/me/has-recurring-payment-details',
    PAYMENTS: '/signups/me/payment',
    TARIFFS: '/users/me/tariffs',
    INVOICES: '/users/me/invoices',
    CONTRACTS: '/users/me/contracts',
    QUOTES: '/users/me/quotes',
    USER_INFO: '/users/me/info',
    UPDATE_USER_INFO: '/users/me/update-info',
    SUBJECTS: '/contactus/support-requests/subjects',
    SUBJECTS_ME: '/contactus/support-requests/me',
    PAYMENT_REDIRECT_URL: '/payments/redirect',
  },
  AUTHORIZATION: {
    TOKEN: '/oauth/token',
    CREATE: '/users/create',
    RESET_PASSWORD: '/users/reset-password',
    PASSWORD_TOKEN_STATUS: '/users/get-password-token-status',
    ME: '/users/me',
    CHANGE_PASSWORD: '/users/change-password',
    SET_PASSWORD: '/users/set-password',
  },
  CUSTOMER_LIFE_CYCLE: {
    PAYOUT_ENERGY_TARIFF: '/registration/payout-energy-tariff',
    FLEET_DATA: '/registration/fleetdata',
  },
  PAYAUT_SERVICE: {
    ACCOUNT: 'me/account',
    PAYOUT_IBAN: 'me/account/payout-iban',
    KYC_URL: 'me/account/kyc-url',
    KYC_STATUS: 'me/account/kyc-status',
  },
  CHARGER_MANAGEMENT: {
    CHARGERS: '/chargers',
    CHARGER: 'owners/me/chargers',
  },
  DOCUMENTS_MANAGER: {
    DOCUMENT: '/document',
  },
  CONTACT_FORM: {
    CANCELLATION: '/contract-cancellation',
  },
}
